export default "__VITE_PUBLIC_ASSET__361c975c__"